import { render, staticRenderFns } from "./update-resource.vue?vue&type=template&id=1518b864&scoped=true"
import script from "./update-resource.vue?vue&type=script&lang=js"
export * from "./update-resource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1518b864",
  null
  
)

export default component.exports